import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import IconButton from '@mui/material/IconButton'
import { IEvent, ITournament } from 'bets.oddprovider.lib.common.ts/models'
import { NumberUtils } from 'fwork-jsts-common/src'
import { ApiClientUtils } from 'fwork-jsts-common/src/apiClient'
import { FilterQuery } from 'mongoose'
import { useSnackbar } from 'notistack'
import * as React from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import axios from '../../apiClient/axios'
import { EventsApiClient } from '../../apiClient/events'
import { DEFAULTGAP, RoutesNames } from '../../globals'
import { toggleLoading } from '../../redux/reducers/loadingBar.slice'
import { ITournamentsState, tournamentsStateLoadFromApi } from '../../redux/reducers/tournaments.slice'
import { RootState } from '../../redux/store'
import { HeaderComponent } from '../common/header'
import { SearchInputComponent } from '../common/searchInput'
// import { TableComponent } from '../common/table'
// import { StyledListItemText, StyledTableCell, TableComponentSetCurrPageProps } from '../common/table/common'
import { StyledListItemText, StyledTableCell, TableComponent, TableComponentSetCurrPageProps } from 'fwork.react.apptemplate'

const TournamentItemComponent = (props: {
  tournament: ITournament
}) => {


  const navigate = useNavigate()
  const [open, setOpen] = useState<boolean>()
  const [events, setEvents] = useState<IEvent[] | undefined>()
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useDispatch()

  let getting = false
  const getEvents = async () => {
    if (getting) {
      enqueueSnackbar('Operação em andamento. Aguarde...', { variant: 'success' })
      return
    }

    getting = true
    if (!events)
      try {
        dispatch(toggleLoading())
        const response = await new EventsApiClient(axios).get({
          where: {
            'tournament.id': props.tournament.id
          },
          sort: { name: 1 }
        })
        if (response.success && response.data)
          setEvents(response.data.payload)
      } catch (error) {
        enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
      }
      finally {
        dispatch(toggleLoading())
        getting = false
      }
    else getting = false
  }

  return <StyledTableCell style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
    <div style={{
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    }}
    >
      <StyledListItemText
        style={{ cursor: 'pointer', }} onClick={() => {
          navigate(RoutesNames.tournament.replace(':id', props.tournament?.id.toString()))
        }}
        primary={(props.tournament.location?.name ? props.tournament.location?.name + ' - ' : '') + props.tournament.name}
        secondary={props.tournament.id}
      />
      <IconButton style={{ height: 46, width: 46 }} size={'small'}
        onClick={(e) => {
          e.stopPropagation()
          getEvents()
          setOpen(!open)
        }}>
        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </IconButton>
    </div>

    <div>
      {open ? events?.map((event, index) => {
        const participants = event.participants.map((participant, index) => {
          return `${index > 0 ? ' x ' : ''}${participant.name}`
        })
        return <div key={index}>{participants}</div>
      }) : <></>}
    </div>
  </StyledTableCell>
}

export const TournamentsComponent = () => {
  const tableComponentSetCurrPageRef = React.useRef<TableComponentSetCurrPageProps>(() => { });
  const tableComponentSetCurrPage = tableComponentSetCurrPageRef.current

  const tournamentsState: ITournamentsState = useSelector((state: RootState) => state.tournamentsState)
  // const tournaments = [...tournamentsState.payload || []].sort((a, b) => a.name.localeCompare(b.name))
  const tournaments = [...tournamentsState.payload || []]
  const dispatch = useDispatch<any>()
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const [searchText, setSearchText] = useState<string | undefined>()


  const loadTournaments = async () => {
    dispatch(toggleLoading())
    // const where: FilterQuery<ITournament> | undefined = searchText ? {
    //   $or: [
    //     {
    //       name: { $regex: searchText, $options: 'i' },
    //     },
    //     {
    //       id: NumberUtils.onlyNumbers(searchText)
    //     }]
    // } : undefined
    let searchTextMult = searchText?.split(' ')

    const where: FilterQuery<ITournament> | undefined = searchText ? {
      $and: [
        {
          location_id: { $gte: 0 }
        },
        {
          $or: [
            // {
            //   $and: [
            //     {
            //       $or: searchTextMult?.map(st => ({ name: { $regex: st, $options: "i" } }))
            //     },
            //     {
            //       $or: searchTextMult?.map(st => ({ "location.name": { $regex: st, $options: "i" } }))
            //     },
            //   ]
            // },
            {
              full_name: {
                $regex: searchTextMult?.reduce((a, b) => {
                  if (!a.includes('(?=.*'))
                    a = `(?=.*${a})`
                  b = `(?=.*${b})`
                  let result = `${a}${b}`
                  return result
                }),
                $options: "i"
              }
            },
            {
              name: { $regex: searchText, $options: 'i' }
            },
            {
              "location.name": { $regex: searchText, $options: 'i' }
            },
            {
              id: NumberUtils.onlyNumbers(searchText)
            }
          ]
        }
      ]
    } : undefined

    const response = await dispatch(tournamentsStateLoadFromApi({
      where,
      onFinally: () => {
        dispatch(toggleLoading())

        if (tableComponentSetCurrPage)
          tableComponentSetCurrPage({
            page: 0
          })
      },
      onError: (msg) => {
        enqueueSnackbar(ApiClientUtils.getErrorMessage(msg), { variant: 'error' })
      }
    }))

    if (!response.payload?.data?.payload?.length) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage('Nenhum registro encontrado'), { variant: 'warning' })
    }
  }

  return <>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      paddingBottom: DEFAULTGAP
    }}>
      <HeaderComponent
        props={{
          style: {
            paddingInline: DEFAULTGAP
          }
        }}
        title='Torneios'
        onRefreshClick={loadTournaments}
        onAddClick={() => navigate(RoutesNames.tournament)}
      />

      <SearchInputComponent
        style={{
          marginInline: DEFAULTGAP,
          maxWidth: 500
        }}
        label='Pesquisar por código ou nome'
        onChange={e => setSearchText(e.target.value)}
        onKeyUp={e => { if (e.key === "Enter") loadTournaments() }}
        onIconClick={loadTournaments}
      />

      <TableComponent
        wrapperProps={{ style: { padding: DEFAULTGAP, maxWidth: 'calc(100% - 10px)' } }}
        setCurrPageRef={tableComponentSetCurrPageRef}
        bodyList={tournaments}
        bodyRowBuilder={(tournament: ITournament) => <>
          <TournamentItemComponent tournament={tournament} key={tournament.id} />
        </>}
      />
    </div>
  </>
}